import React, { useContext, useEffect, useState } from "react";
import { Col, Button, Image, Form, Row } from "react-bootstrap";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import Itinerary from "../../../../../../Data/Itinerary";
import { Adjustment } from "../../../../../../Data/Reservation/Adjustment";

interface props {
  item: Adjustment;
  quoteStatus: number | undefined;
}

const LodgingTab: React.FC<props> = (props) => {
  const { style } = useContext(WidgetContext);
  const { item, quoteStatus } = props;

  return (
    <React.Fragment>
      {/* Lodging Items */}
      {/* Desktop */}

      {item.showOnItinerary && (
        <>
          <Row className="d-none d-md-flex flex-row item-container">
            {/* Form */}
            <Col xs={7} className="pl-3">
              {/* Selects */}
              <Row
                className="w-100 d-flex flex-row justify-content-start"
                style={{ marginTop: "10px" }}
              >
                <Col xs={6} className="d-flex flex-column">
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Adjustment Type
                  </Form.Label>
                  <Form.Control
                    style={{ color: style.fontColor }}
                    as="input"
                    className=""
                    disabled={true}
                    readOnly={true}
                    value={item.adjustmentName} >
                  </Form.Control>
                </Col>

                {(quoteStatus == 20 || quoteStatus == 30) && (
                  <div className="d-flex flex-column mr-0 ml-2">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Confirmation #
                    </Form.Label>
                    <Form.Control
                      className="font-italic"
                      style={{ color: item.confirmationNumber ? "green" : "red" }}
                      type="text"
                      value={item.confirmationNumber ? item.confirmationNumber : "Pending Confirmation"}
                      readOnly={true}
                      disabled={true}
                    >
                    </Form.Control>
                  </div>
                )}
              </Row>
            </Col>
            <Col
              xs={1}
              className={`ml-auto mr-0 d-flex flex-column justify-content-end`}
            >
              <div className="add-buttons">
                <p className="m-0 p-0 pr-1 text-right font-weight-bold green-text">${(item.sell * item.numUnits).toFixed(2)}</p>
              </div>
            </Col>
          </Row>

          {/* Mobile  */}
          <Col className="d-md-none">
            <Row className="w-100 mt-3">
              <Col xs={8}>
                <h6 style={{ color: style.fontColor, fontSize: 14 }} className="mobile-item-header">{item.adjustmentName}</h6>
                <p style={{ color: style.fontColor, fontSize: 14 }} className="m-0 p-0">{item.numUnits ? item.numUnits : 1} Unit{item.numUnits && item.numUnits != 1 ? "s" : ""}
                </p>
              </Col>
            </Row>
            <Row className="d-flex flex-row mobile-divider" />
          </Col>
        </>
      )}
    </React.Fragment>
  );
}

export default LodgingTab;
